/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_EyebrowInputs */

const en_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

const es_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda`)
};

const de_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitplan`)
};

const zh_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程`)
};

const ar_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجدولة`)
};

const fr_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendrier`)
};

const vi_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch trình`)
};

const sw_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratiba`)
};

const th_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำหนดการ`)
};

const bs_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakazivanje`)
};

const ja_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スケジュール`)
};

const ko_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일정`)
};

const pt_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agendar`)
};

const it_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orari`)
};

const sv_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

const nl_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

const da_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skema`)
};

const nb_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlegging`)
};

const fi_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aikataulu`)
};

const pl_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminarz`)
};

const ru_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расписание`)
};

const tr_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Randevu`)
};

const hi_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुसूची`)
};

const id_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal`)
};

const ms_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadual`)
};

const cs_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plán`)
};

const el_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρόγραμμα`)
};

const he_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לוח זמנים`)
};

const af_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skedule`)
};

const hu_booking_eyebrow = /** @type {(inputs: Booking_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Időpontfoglalás`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {Booking_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_eyebrow = /** @type {((inputs?: Booking_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_eyebrow(inputs)
	if (locale === "de") return de_booking_eyebrow(inputs)
	if (locale === "zh") return zh_booking_eyebrow(inputs)
	if (locale === "ar") return ar_booking_eyebrow(inputs)
	if (locale === "fr") return fr_booking_eyebrow(inputs)
	if (locale === "vi") return vi_booking_eyebrow(inputs)
	if (locale === "sw") return sw_booking_eyebrow(inputs)
	if (locale === "th") return th_booking_eyebrow(inputs)
	if (locale === "bs") return bs_booking_eyebrow(inputs)
	if (locale === "ja") return ja_booking_eyebrow(inputs)
	if (locale === "ko") return ko_booking_eyebrow(inputs)
	if (locale === "pt") return pt_booking_eyebrow(inputs)
	if (locale === "it") return it_booking_eyebrow(inputs)
	if (locale === "sv") return sv_booking_eyebrow(inputs)
	if (locale === "nl") return nl_booking_eyebrow(inputs)
	if (locale === "da") return da_booking_eyebrow(inputs)
	if (locale === "nb") return nb_booking_eyebrow(inputs)
	if (locale === "fi") return fi_booking_eyebrow(inputs)
	if (locale === "pl") return pl_booking_eyebrow(inputs)
	if (locale === "ru") return ru_booking_eyebrow(inputs)
	if (locale === "tr") return tr_booking_eyebrow(inputs)
	if (locale === "hi") return hi_booking_eyebrow(inputs)
	if (locale === "id") return id_booking_eyebrow(inputs)
	if (locale === "ms") return ms_booking_eyebrow(inputs)
	if (locale === "cs") return cs_booking_eyebrow(inputs)
	if (locale === "el") return el_booking_eyebrow(inputs)
	if (locale === "he") return he_booking_eyebrow(inputs)
	if (locale === "af") return af_booking_eyebrow(inputs)
	if (locale === "hu") return hu_booking_eyebrow(inputs)
	return en_booking_eyebrow(inputs)
});